import Logo from '../assets/images/logo.png';

const Nav = () => {
    return (
    <nav className="nav" id="nav">
        <div className="contentWrapper">
            <a href="https://livingatcivic66.com/"><img src={Logo} alt="Civic 66" /></a>
            <a className="btn" href="https://livingatcivic66.com/">Return to livingatcivic66.com</a>
        </div>
    </nav>)
}

export default Nav